[
    {
        "type": "general",
        "label": "General",
        "options": [
            {
                "label": "Loss of appetite",
                "type": "lossofappetite"
            },
            {
                "label": "Increased Hunger",
                "type": "increasedhunger"
            },
            {
                "label": "Weight Change",
                "type": "weightchange"
            },
            {
                "label": "Body Chills",
                "type": "bodychills"
            },
            {
                "label": "Energy Level",
                "type": "energylevel",
                "optionSelections": [
                    "Normal",
                    "Tired",
                    "Exhausted"
                ]
            },
            {
                "label": "Dizziness",
                "type": "dizziness"
            },
            {
                "label": "Unable to Sleep",
                "type": "unabletosleep"
            },
            {
                "label": "General Body Weakness",
                "type": "bodyweakness"
            },
            {
                "label": "Fever",
                "type": "fever"
            },
            {
                "label": "Mood",
                "type": "mood",
                "optionSelections": [
                    "Feeling Good",
                    "Social",
                    "Anxious",
                    "Stressed",
                    "Depressed"
                ]
            },
            {
                "label": "Memory Loss",
                "type": "memoryloss"
            }
        ]
    },
    {
        "type": "skin",
        "label": "Skin",
        "options": [
            {
                "label": "Rash",
                "type": "rash"
            },
            {
                "label": "Change in Mole/Spot",
                "type": "changeinmolespot"
            },
            {
                "label": "Cut/Laceration",
                "type": "cutlaceration"
            },
            {
                "label": "Large Abrasion",
                "type": "largeabrasion"
            },
            {
                "label": "Puncture",
                "type": "puncture"
            },
            {
                "label": "Insect Bite or Sting",
                "type": "insectbiteorsting"
            }
        ]
    },
    {
        "type": "henetm",
        "label": "Head, Eyes, Nose, Ears, Throat, and Mouth",
        "options": [
            {
                "label": "Head",
                "type": "head",
                "optionSelections": [
                    "Headache",
                    "Head Injury"
                ],
                "multi": true
            },
            {
                "label": "Eyes",
                "type": "eyes",
                "optionSelections": [
                    "Burning",
                    "Foreign Body",
                    "Specks",
                    "Irritation",
                    "Discharge",
                    "Double Vision",
                    "Vision Loss",
                    "Tearing",
                    "Itchy",
                    "Sensitive to Light",
                    "Redness"
                ],
                "multi": true
            },
            {
                "label": "Ear",
                "type": "ear",
                "optionSelections": [
                    "Ear Discharge",
                    "Ringing in Ear",
                    "Hearing Loss",
                    "Earache"
                ],
                "multi": true
            },
            {
                "label": "Nose",
                "type": "nose",
                "optionSelections": [
                    "Runny Nose",
                    "Loss of Smell",
                    "Frequent Nose Bleeds",
                    "Sneezing",
                    "Congestion",
                    "Sinus Pressure",
                    "Sinus Pain"
                ],
                "multi": true
            },
            {
                "label": "Throat & Mouth",
                "type": "throatmouth",
                "optionSelections": [
                    "Sore Throat",
                    "Sore Tongue",
                    "Painful Swallowing",
                    "Hoarseness",
                    "Post Nasal Drip",
                    "Thrush",
                    "Non Healing Sores"
                ],
                "multi": true
            },
            {
                "label": "Dental",
                "type": "dental",
                "optionSelections": [
                    "Sore Gums",
                    "Sensivity to Hot or Cold",
                    "Painful Chewing",
                    "Bleeding Gums",
                    "Non Healing Sores"
                ],
                "multi": true
            }
        ]
    },
    {
        "type": "lungsandchest",
        "label": "Lungs & Chest",
        "options": [
            {
                "label": "Shortness of breath",
                "type": "shortnessbreath",
                "optionSelections": [
                    "Sleeping",
                    "Lying Down",
                    "Exercise"
                ],
                "multi": true
            },
            {
                "label": "Wheezing",
                "type": "wheezing"
            },
            {
                "label": "Cough",
                "type": "cough",
                "optionSelections": [
                    "Dry",
                    "Wet"
                ]
            },
            {
                "label": "Chest Pain with Breathing",
                "type": "chestpainbreating"
            },
            {
                "label": "Chest tightness",
                "type": "chesttightness"
            },
            {
                "label": "Palpitations",
                "type": "palpitations"
            },
            {
                "label": "Swelling",
                "type": "swelling"
            }
        ]
    },
    {
        "type": "stomachandabdomen",
        "label": "Stomach & Abdomen",
        "options": [
            {
                "label": "Abdominal Pain",
                "type": "abdominalpain"
            },
            {
                "label": "Bloating",
                "type": "bloating"
            },
            {
                "label": "Constipation",
                "type": "constipation"
            },
            {
                "label": "Diarrhea",
                "type": "diarrhea"
            },
            {
                "label": "Nausea",
                "type": "nausea"
            },
            {
                "label": "Vomitting",
                "type": "vomitting"
            },
            {
                "label": "Gas",
                "type": "gas"
            },
            {
                "label": "Rectal Rleeding",
                "type": "rectalbleeding"
            },
            {
                "label": "Yellow Eyes or Skin",
                "type": "yelloweyesskin"
            },
            {
                "label": "Heartburn",
                "type": "heartburn"
            }
        ]
    },
    {
        "type": "extremities",
        "label": "Extremities",
        "options": [
            {
                "label": "Pain",
                "type": "pain",
                "optionSelections": [
                    "Throbbing",
                    "Radiating",
                    "Sharp",
                    "OnContact"
                ],
                "multi": true
            },
            {
                "label": "Swelling",
                "type": "swelling"
            },
            {
                "label": "Range of Motion Limitations",
                "type": "rangeofmotionlimit",
                "optionSelections": [
                    "Leg",
                    "Knee",
                    "Foot",
                    "Arm",
                    "Elbow",
                    "Hand",
                    "Finger",
                    "Shoulder",
                    "Toe",
                    "Foot",
                    "Ankle"
                ],
                "multi": true
            },
            {
                "label": "Redness of Joints",
                "type": "rednessjoints"
            },
            {
                "label": "Trauma",
                "type": "trauma"
            },
            {
                "label": "Cramping & Pain while walking - Vascular",
                "type": "cramppainwalkingvascular"
            }
        ]
    },
    {
        "type": "neckandback",
        "label": "Spine (Neck and Back)",
        "options": [
            {
                "label": "Back Pain",
                "type": "backpain",
                "optionSelections": [
                    "Upper",
                    "Mid",
                    "Lower",
                    "Acute",
                    "Chronic"
                ],
                "multi": true
            },
            {
                "label": "Neck Pain",
                "type": "neckpain",
                "optionSelections": [
                    "Stiffness",
                    "Swollenglands",
                    "Lumps"
                ],
                "multi": true
            },
            {
                "label": "Pain",
                "type": "pain",
                "optionSelections": [
                    "Throbbing",
                    "Radiating",
                    "Sharp",
                    "OnContact"
                ],
                "multi": true
            }
        ]
    },
    {
        "type": "reproductivesystem",
        "label": "Reproductive System",
        "options": [
            {
                "label": "Testicular Pain",
                "type": "testicularpain",
                "applicableSex": "M"
            },
            {
                "label": "Pain while Urinating",
                "type": "painurinating",
                "applicableSex": "M"
            },
            {
                "label": "Erectile Pain",
                "type": "erectilepain",
                "applicableSex": "M"
            },
            {
                "label": "Penile Discharge",
                "type": "peniledischarge",
                "applicableSex": "M"
            },
            {
                "label": "Decreased Libido",
                "type": "decreasedlibido",
                "applicableSex": "M"
            },
            {
                "label": "Sexual Dysfunction",
                "type": "sexualdysfunction",
                "applicableSex": "M"
            },
            {
                "label": "Sores",
                "type": "sores"
            },
            {
                "label": "STDs",
                "type": "std"
            },
            {
                "label": "Hernia",
                "type": "hernia",
                "applicableSex": "M"
            },
            {
                "label": "Pain with Sex",
                "type": "painsex"
            },
            {
                "label": "Vaginal Dryness",
                "type": "vaginaldryness",
                "applicableSex": "F"
            },
            {
                "label": "Masses or Pain",
                "type": "massespain",
                "applicableSex": "F"
            },
            {
                "label": "Hot flashes",
                "type": "hotflashes",
                "applicableSex": "F"
            },
            {
                "label": "Vaginal Discharge",
                "type": "vaginaldischarge",
                "applicableSex": "F"
            },
            {
                "label": "Itching/Rashes",
                "type": "itchingrashes",
                "applicableSex": "F"
            }
        ]
    },
    {
        "type": "urinary",
        "label": "Urinary",
        "options": [
            {
                "label": "Frequency",
                "type": "frequency"
            },
            {
                "label": "Urgency",
                "type": "urgency"
            },
            {
                "label": "Burning or Pain",
                "type": "burningorpain"
            },
            {
                "label": "Blood in Urine",
                "type": "bloodurine"
            },
            {
                "label": "Incontinence",
                "type": "incontinence"
            },
            {
                "label": "Change in Urinary Strength",
                "type": "urinarystrength"
            }
        ]
    },
    {
        "type": "neurologic",
        "label": "Neurologic",
        "options": [
            {
                "label": "Dizziness",
                "type": "dizziness"
            },
            {
                "label": "Fainting",
                "type": "fainting"
            },
            {
                "label": "Seizures",
                "type": "seizures"
            },
            {
                "label": "Weakness",
                "type": "weakness"
            },
            {
                "label": "Numbness",
                "type": "numbness"
            },
            {
                "label": "Tingling",
                "type": "tingling"
            },
            {
                "label": "Tremor",
                "type": "tremor"
            }
        ]
    },
    {
        "type": "endocrine",
        "label": "Endocrine",
        "options": [
            {
                "label": "Heat or Cold Intolerance",
                "type": "heatcoldintolerance"
            },
            {
                "label": "Sweating",
                "type": "sweating"
            },
            {
                "label": "Thirst",
                "type": "thirst"
            },
            {
                "label": "Frequent Urination",
                "type": "frequenturination"
            },
            {
                "label": "Change in Appetite",
                "type": "changeinappetite"
            }
        ]
    }
]